import React, { useEffect, useState, Dispatch, SetStateAction } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { SettingsState } from '../../../organisms/SelectSettings';
import {
  Grid,
  Paper,
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Button,
  TableHead,
} from '@material-ui/core';
import GroupTitle from '../GroupTitle';
import {
  GroupListType,
  XY_CMP_GROUP_SET,
  XYDeviceSelectItem,
  GetXYComparisonGroupList,
  XYItemSelectItem,
  PutXYComparisonGroupList,
} from '../../../../function/GroupDataModel';
import dayjs from 'dayjs';
import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import XYDeviceItem from './XYDeviceItem';
import SaveCancel from '../SaveCancel';
import { useModal, DialogAction } from '../../../../function/useModal';
import ConfirmDialog, { ConfirmDialogResponse } from '../../../atoms/Dialog/ConfirmDialog';
import MessageDialog, { MessageDialogResponse } from '../../../atoms/Dialog/MessageDialog';
import { useTranslation } from 'react-i18next';
import CreateGroupDialog, { CreateGroupDialogResponse } from '../CreateGroupDialog';

import { TableBaseStyle } from './XYCompansonSettingSytle';
import XYDateSettingsProps from './XYDateSettings';

type XYComparisonSettingProps = {
  editData: SettingsState;
  groupNo?: number;
  isDialog: boolean;
};

type SaveParameter = {
  list: XY_CMP_GROUP_SET[];
};

const MaxGroup: number = 256;

/**赤色 */
export const DspColor1: number = 255;
/**青色 */
export const DspColor2: number = 16711680;
/**緑色 */
export const DspColor3: number = 65280;
/**水色 */
export const DspColor4: number = 16776960;

//カレンダー
const fromCalendar: Date = new Date();
(fromCalendar.setFullYear(fromCalendar.getFullYear() - 1)).toString().padStart(4, '0');
//(fromCalendar.setDate(fromCalendar.getDate() + 1)).toString().padStart(2, '0');
const toCalendar: Date = new Date();
(toCalendar.setDate(toCalendar.getDate() - 1)).toString().padStart(2, '0');

const XYComparisonSetting: React.FC<XYComparisonSettingProps> = (props: XYComparisonSettingProps) => {
  const { t } = useTranslation();
  const classes = TableBaseStyle();
  const [groupNo, setGroupNo] = useState<number>(0);
  const [editList, setEditList] = useState<XY_CMP_GROUP_SET[]>([]);
  const [groupName, setGroupName] = useState<string>('');
  const [selectList, setSelectList] = useState<XYDeviceSelectItem[]>([]);
  const [groupCombos, setGroupCombos] = useState<ComboBoxItemType[]>();
  const [devIdx, setDevIdx] = useState<number>(0);
  const [plcNoX, setPlcNoX] = useState<number>(0);
  const [setNoX, setSetNoX] = useState<number>(0);
  const [plcNoY, setPlcNoY] = useState<number>(0);
  const [setNoY, setSetNoY] = useState<number>(0);
  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
  const [dlgmsg, setDlgmsg] = useState<string>('');
  const [flgCrtDlg, actCrtDlg] = useModal<CreateGroupDialogResponse>();

  const [edit, setEdit] = useState<XY_CMP_GROUP_SET>(() => {
    const defaulltData: XY_CMP_GROUP_SET = {
      GROUP_NO: 0,
      GROUP_NAME: '',
      DSP_FLG: 0,
      DEV_INDEX: 0,
      PLC_NO_X: 0,
      SET_NO_X: 0,
      PLC_NO_Y: 0,
      SET_NO_Y: 0,
      YEAR_FLG: 0,
      MONTH_FLG: 0,
      START_DATE: '',
      END_DATE: '',
      START_MONTH1: 0,
      END_MONTH1: 0,
      DSP_COLOR1: DspColor1,  //赤色
      START_MONTH2: 0,
      END_MONTH2: 0,
      DSP_COLOR2: DspColor2, //青色
      START_MONTH3: 0,
      END_MONTH3: 0,
      DSP_COLOR3: DspColor3,  //緑色
      START_MONTH4: 0,
      END_MONTH4: 0,
      DSP_COLOR4: DspColor4, //水色
    };
    return defaulltData;
  })

  const cfmdlg = flgCfmDlg ? (
    <ConfirmDialog
      dialog={actCfmDlg}
      message={dlgmsg}
      action={t('XYComparisonSetting.はい', 'はい')}
      cancel={t('XYComparisonSetting.いいえ', 'いいえ')}
    />
  ) : null;
  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;
  const crtdlg = flgCrtDlg ? (
    <CreateGroupDialog dialog={actCrtDlg} exists={groupCombos?.map<number>((gc) => gc.index)} maxGroup={MaxGroup} />
  ) : null;

  console.log('-- XYComparisonSetting --');

  //初期表示
  useEffect(() => {
    console.log('-- fetch xy comparison settings --');
    GetXYComparisonGroupList().then((result: GroupListType) => {
      const groupList: XY_CMP_GROUP_SET[] = result.XY_CMP_GROUP_SETs.filter((xy) => xy.GROUP_NAME !== '');

      const groups = groupList.map<ComboBoxItemType>((grp) => {
        return { index: grp.GROUP_NO, name: grp.GROUP_NO.toString() };
      });
      setGroupCombos(groups);
      setEditList(groupList);

      result.XYDeviceSelects.forEach((r) => {
        r.ItemSelects.forEach((r, index) => {
          r.index = index + 1;
        });
      });

      if (groupList.length > 0) {
        let startGroupNo = 0;
        //X-Y分布図のグラフ表示からのグループ設定呼び出し
        if (props.groupNo) {
          // console.debug(['props.groupNo', props.groupNo])
          startGroupNo = props.groupNo;
        }

        const grps = groupList.filter((r) => r.GROUP_NO == startGroupNo);
        console.debug(['grps', grps, groupList]);

        const grp = grps.length > 0 ? grps[0] : groupList[0];

        console.debug(['grp', grp]);
        setGroupName(grp.GROUP_NAME);
        setDevIdx(grp.DEV_INDEX);
        setPlcNoX(grp.PLC_NO_X);
        setSetNoX(grp.SET_NO_X);
        setPlcNoY(grp.PLC_NO_Y);
        setSetNoY(grp.SET_NO_Y);
        setGroupNo(grp.GROUP_NO);

        let xyGroupSetData: XY_CMP_GROUP_SET = {
          GROUP_NO: grp.GROUP_NO,
          GROUP_NAME: grp.GROUP_NAME,
          DSP_FLG: grp.DSP_FLG,
          DEV_INDEX: grp.DEV_INDEX,
          PLC_NO_X: grp.PLC_NO_X,
          SET_NO_X: grp.SET_NO_X,
          PLC_NO_Y: grp.PLC_NO_Y,
          SET_NO_Y: grp.SET_NO_Y,
          YEAR_FLG: grp.YEAR_FLG,
          MONTH_FLG: grp.MONTH_FLG,
          START_DATE: (grp.START_DATE === null ? dayjs(fromCalendar).format('YYYY-MM-DD') : grp.START_DATE),
          END_DATE: (grp.END_DATE === null ? dayjs(toCalendar).format('YYYY-MM-DD') : grp.END_DATE),
          START_MONTH1: grp.START_MONTH1,
          END_MONTH1: grp.END_MONTH1,
          DSP_COLOR1: grp.DSP_COLOR1 === null ? DspColor1 : grp.DSP_COLOR1,
          START_MONTH2: grp.START_MONTH2,
          END_MONTH2: grp.END_MONTH2,
          DSP_COLOR2: grp.DSP_COLOR2 === null ? DspColor2 : grp.DSP_COLOR2,
          START_MONTH3: grp.START_MONTH3,
          END_MONTH3: grp.END_MONTH3,
          DSP_COLOR3: grp.DSP_COLOR3 === null ? DspColor3 : grp.DSP_COLOR3,
          START_MONTH4: grp.START_MONTH4,
          END_MONTH4: grp.END_MONTH4,
          DSP_COLOR4: grp.DSP_COLOR4 === null ? DspColor4 : grp.DSP_COLOR4,
        }
        setEdit(xyGroupSetData);
      }
      setSelectList(result.XYDeviceSelects);

      props.editData.SaveFunction = saveCurrentSetting;
      props.editData.IsUpdate = false;
    });
  }, [props.editData.CancelCondition]);

  useEffect(() => {
    // const groups = editList.map<ComboBoxItemType>((grp) => {
    //   return { index: grp.GROUP_NO, name: grp.GROUP_NO.toString() };
    // });
    // setGroupCombos(groups);
    // if (!editList.find((el) => el.GROUP_NO == groupNo)) {
    //   if (editList.length > 0) {
    //     const grp = editList[0];
    //     setDevIdx(grp.DEV_INDEX);
    //     setPlcNoX(grp.PLC_NO_X);
    //     setSetNoX(grp.SET_NO_X);
    //     setPlcNoY(grp.PLC_NO_Y);
    //     setSetNoY(grp.SET_NO_Y);
    //     setGroupNo(grp.GROUP_NO);
    //   }
    // }
  }, [editList]);

  /**
   * グループNo変更イベント
   * @param no 
   */
  const groupChange = (no: number) => {
    updateDispFlg();
    const grp = editList?.find((ed) => ed.GROUP_NO === no);
    if (grp) {
      setGroupName(grp.GROUP_NAME ?? '');

      if (selectList) {
        setDevIdx(grp.DEV_INDEX);
        setPlcNoX(grp.PLC_NO_X);
        setSetNoX(grp.SET_NO_X);
        setPlcNoY(grp.PLC_NO_Y);
        setSetNoY(grp.SET_NO_Y);

        let xyGroupSetData: XY_CMP_GROUP_SET = {
          GROUP_NO: grp.GROUP_NO,
          GROUP_NAME: grp.GROUP_NAME,
          DSP_FLG: grp.DSP_FLG,
          DEV_INDEX: grp.DEV_INDEX,
          PLC_NO_X: grp.PLC_NO_X,
          SET_NO_X: grp.SET_NO_X,
          PLC_NO_Y: grp.PLC_NO_Y,
          SET_NO_Y: grp.SET_NO_Y,
          YEAR_FLG: grp.YEAR_FLG,
          MONTH_FLG: grp.MONTH_FLG,
          START_DATE: (grp.START_DATE === null ? dayjs(fromCalendar).format('YYYY-MM-DD') : grp.START_DATE),
          END_DATE: (grp.END_DATE === null ? dayjs(toCalendar).format('YYYY-MM-DD') : grp.END_DATE),
          START_MONTH1: grp.START_MONTH1,
          END_MONTH1: grp.END_MONTH1,
          DSP_COLOR1: grp.DSP_COLOR1 === null ? DspColor1 : grp.DSP_COLOR1,
          START_MONTH2: grp.START_MONTH2,
          END_MONTH2: grp.END_MONTH2,
          DSP_COLOR2: grp.DSP_COLOR2 === null ? DspColor2 : grp.DSP_COLOR2,
          START_MONTH3: grp.START_MONTH3,
          END_MONTH3: grp.END_MONTH3,
          DSP_COLOR3: grp.DSP_COLOR3 === null ? DspColor3 : grp.DSP_COLOR3,
          START_MONTH4: grp.START_MONTH4,
          END_MONTH4: grp.END_MONTH4,
          DSP_COLOR4: grp.DSP_COLOR4 === null ? DspColor4 : grp.DSP_COLOR4,
        }
        setEdit(xyGroupSetData);
      }
    }
    setGroupNo(no);
  };

  const updateDispFlg = () => {
    const grp = editList?.find((ed) => ed.GROUP_NO == groupNo);
    if (grp) {
      if (grp.GROUP_NAME == '' && grp.PLC_NO_X == 0 && grp.PLC_NO_Y == 0) {
        grp.DSP_FLG = 0;
      } else {
        grp.DSP_FLG = 1;
      }
    }
  };
  /**
   * グループ名称変更イベント
   * @param name 
   */
  const groupNameChange = (name: string) => {
    const grp = editList?.find((ed) => ed.GROUP_NO == groupNo);
    if (grp) {
      setGroupName(name);
      grp.GROUP_NAME = name;
      updateDispFlg();

      props.editData.Target = { list: editList };
      props.editData.IsUpdate = true;
    }
  };
  /**
   * 
   * @param devIdx 
   * @param plcX 
   * @param setX 
   * @param plcY 
   * @param setY 
   */
  const groupPlcSet = (devIdx: number, plcX: number, setX: number, plcY: number, setY: number) => {
    console.debug(['DataUpdate--', 'devIdx', devIdx, 'plcX', plcX, 'setX', setX, 'plcY', plcY, 'setY', setY]);
    const grp = editList?.find((ed) => ed.GROUP_NO == groupNo);
    if (grp) {
      grp.DEV_INDEX = devIdx;
      grp.PLC_NO_X = plcX;
      grp.SET_NO_X = setX;
      grp.PLC_NO_Y = plcY;
      grp.SET_NO_Y = setY;
      updateDispFlg();

      if (selectList) {
        setDevIdx(grp.DEV_INDEX);
        setPlcNoX(grp.PLC_NO_X);
        setSetNoX(grp.SET_NO_X);
        setPlcNoY(grp.PLC_NO_Y);
        setSetNoY(grp.SET_NO_Y);
      }

      props.editData.Target = { list: editList };
      props.editData.IsUpdate = true;
    }
  };
  /**
   * 保存
   * @param param 
   * @returns 
   */
  const saveCurrentSetting = (param: object): Promise<string> => {
    return new Promise((resolve, reject) => {
      const sp = param as SaveParameter;
      //console.debug(["SaveParameter", sp])
      if (sp && sp.list) {
        //保存前チェック
        const errmsg = validateSetting(sp.list);
        if (errmsg === '') {
          PutXYComparisonGroupList(sp.list)
            .then((count: number) => {
              console.log(count);

              resolve('done');
            })
            .catch((reasone) => reject(reasone));
        } else {
          setDlgmsg(errmsg);
          actMsgDlg.open().apply((_) => setDlgmsg(''));
          reject('not save');
        }
      } else {
        reject('data nothing');
      }
    });
  };

  /**
   * nullか0を判定する関数
   * @param value 
   * @returns 
   */
  function isNullOrZero(value: number | null): boolean {
    return value === null || value === 0;
  }
  /**
   * 保存前のエラーメッセージ
   * @param groups 
   * @returns 
   */
  const validateSetting = (groups: XY_CMP_GROUP_SET[]): string => {
    for (var idx = 0; idx < groups.length; idx++) {
      //グループ名
      if (groups[idx].GROUP_NAME == '') {
        return t('XYComparisonSetting.グループ名必須', 'グループ名は必須です');
      }
      /**
       * カレンダー確認処理
       */
      if (groups[idx].YEAR_FLG !== null) {
        if (groups[idx].START_DATE >= groups[idx].END_DATE) {
          return t('XYComparisonSetting.グループNo', 'グループNo.') +
            `${groups[idx].GROUP_NO}:` + t('XYComparisonSetting.開始日_>_終了日になっています', '開始日 > 終了日になっています');
        }
        //設定範囲が5年を超過していないか確認
        let startDate = new Date(groups[idx].START_DATE);
        let endDate = new Date(groups[idx].END_DATE);
        //終了日と開始日の差分を計算し日数に置換え
        let diff = (endDate.getTime() - startDate.getTime()) / (24 * 60 * 60 * 1000);
        console.debug(['X-Ygroup year setting check', startDate, endDate, diff]);
        if (diff > 1826) {
          return t('XYComparisonSetting.グループNo', 'グループNo.') +
            `${groups[idx].GROUP_NO}:` + t('XYComparisonSetting.年設定の期間が5年を超過しています', '年設定の期間が5年を超過しています');
        }
      }

      //月設定ONの場合
      if (groups[idx].MONTH_FLG == 1) {
        //各月設定グループで設定があるか確認
        if (isNullOrZero(groups[idx].START_MONTH1) &&
          isNullOrZero(groups[idx].END_MONTH1) &&
          isNullOrZero(groups[idx].START_MONTH2) &&
          isNullOrZero(groups[idx].END_MONTH2) &&
          isNullOrZero(groups[idx].START_MONTH3) &&
          isNullOrZero(groups[idx].END_MONTH3) &&
          isNullOrZero(groups[idx].START_MONTH4) &&
          isNullOrZero(groups[idx].END_MONTH4)
        ) {
          //
          return t('XYComparisonSetting.グループNo', 'グループNo.') +
            `${groups[idx].GROUP_NO}:` + t('XYComparisonSetting.月設定が行われていません', '月設定が行われていません');
        }
        //色設定が全てnullの場合
        if (groups[idx].DSP_COLOR1 === null &&
          groups[idx].DSP_COLOR2 === null &&
          groups[idx].DSP_COLOR3 === null &&
          groups[idx].DSP_COLOR4 === null
        ) {
          return t('XYComparisonSetting.グループNo', 'グループNo.') +
            `${groups[idx].GROUP_NO}:` + t('XYComparisonSetting.色設定が行われていません', '色設定が行われていません');
        }
      }
      //月設定1
      if (!(isNullOrZero(groups[idx].START_MONTH1)) && (isNullOrZero(groups[idx].END_MONTH1)) ||
        (isNullOrZero(groups[idx].START_MONTH1)) && !(isNullOrZero(groups[idx].END_MONTH1))
      ) {
        return t('XYComparisonSetting.グループNo', 'グループNo.') +
          `${groups[idx].GROUP_NO}:` + t('XYComparisonSetting.月設定1が片方のみ設定されています', '月設定1が片方のみ設定されています');
      }
      //同色確認
      if (groups[idx].DSP_COLOR1 !== null) {
        console.debug(['color check1', groups[idx]])
        if (groups[idx].DSP_COLOR1 === groups[idx].DSP_COLOR2 ||
          groups[idx].DSP_COLOR1 === groups[idx].DSP_COLOR3 ||
          groups[idx].DSP_COLOR1 === groups[idx].DSP_COLOR4
        ) {
          return t('XYComparisonSetting.グループNo', 'グループNo.') +
            `${groups[idx].GROUP_NO}:` + t('XYComparisonSetting.同じ色が設定されています', '同じ色が設定されています');
        }
      }
      //月設定2
      if (!(isNullOrZero(groups[idx].START_MONTH2)) && (isNullOrZero(groups[idx].END_MONTH2)) ||
        (isNullOrZero(groups[idx].START_MONTH2)) && !(isNullOrZero(groups[idx].END_MONTH2))
      ) {
        return t('XYComparisonSetting.グループNo', 'グループNo.') +
          `${groups[idx].GROUP_NO}:` + t('XYComparisonSetting.月設定2が片方のみ設定されています', '月設定2が片方のみ設定されています');
      }
      //同色確認
      if (groups[idx].DSP_COLOR2 !== null) {
        console.debug(['color check2', groups[idx]])
        if (groups[idx].DSP_COLOR2 === groups[idx].DSP_COLOR1 ||
          groups[idx].DSP_COLOR2 === groups[idx].DSP_COLOR3 ||
          groups[idx].DSP_COLOR2 === groups[idx].DSP_COLOR4
        ) {
          return t('XYComparisonSetting.グループNo', 'グループNo.') +
            `${groups[idx].GROUP_NO}:` + t('XYComparisonSetting.同じ色が設定されています', '同じ色が設定されています');
        }
      }
      //月設定3 
      if (!(isNullOrZero(groups[idx].START_MONTH3)) && (isNullOrZero(groups[idx].END_MONTH3)) ||
        isNullOrZero(groups[idx].START_MONTH3) && !(isNullOrZero(groups[idx].END_MONTH3))
      ) {
        return t('XYComparisonSetting.グループNo', 'グループNo.') +
          `${groups[idx].GROUP_NO}:` + t('XYComparisonSetting.月設定3が片方のみ設定されています', '月設定3が片方のみ設定されています');
      }
      //同色確認
      if (groups[idx].DSP_COLOR3 !== null) {
        console.debug(['color check3', groups[idx]])
        if (groups[idx].DSP_COLOR3 === groups[idx].DSP_COLOR1 ||
          groups[idx].DSP_COLOR3 === groups[idx].DSP_COLOR2 ||
          groups[idx].DSP_COLOR3 === groups[idx].DSP_COLOR4
        ) {
          return t('XYComparisonSetting.グループNo', 'グループNo.') +
            `${groups[idx].GROUP_NO}:` + t('XYComparisonSetting.同じ色が設定されています', '同じ色が設定されています');
        }
      }
      //月設定4
      if (!(isNullOrZero(groups[idx].START_MONTH4)) && (isNullOrZero(groups[idx].END_MONTH4)) ||
        (isNullOrZero(groups[idx].START_MONTH4)) && !(isNullOrZero(groups[idx].END_MONTH4))
      ) {
        return t('XYComparisonSetting.グループNo', 'グループNo.') +
          `${groups[idx].GROUP_NO}:` + t('XYComparisonSetting.月設定4が片方のみ設定されています', '月設定4が片方のみ設定されています');
      }
      //同色確認
      if (groups[idx].DSP_COLOR4 !== null) {
        console.debug(['color check4', groups[idx]])
        if (groups[idx].DSP_COLOR4 === groups[idx].DSP_COLOR1 ||
          groups[idx].DSP_COLOR4 === groups[idx].DSP_COLOR2 ||
          groups[idx].DSP_COLOR4 === groups[idx].DSP_COLOR3
        ) {
          return t('XYComparisonSetting.グループNo', 'グループNo.') +
            `${groups[idx].GROUP_NO}:` + t('XYComparisonSetting.同じ色が設定されています', '同じ色が設定されています');
        }
      }

      //月設定範囲の重複チェック
      let checkMsg = checkMonthSettings(groups[idx]);
      if (checkMsg !== '') {
        return t('XYComparisonSetting.グループNo', 'グループNo.') +
          `${groups[idx].GROUP_NO}:` + checkMsg;
      }
    }
    return '';
  };
  /**
   * 削除処理
   * @param param 
   * @returns 
   */
  const deleteCurrentSetting = (param: object): Promise<string> => {
    return new Promise((resolve, reject) => {
      const sp = param as SaveParameter;
      if (sp && sp.list) {
        PutXYComparisonGroupList(sp.list)
          .then((count: number) => {
            console.log(count);

            resolve('done');
          })
          .catch((reasone) => reject(reasone));
      } else {
        reject('data nothing');
      }
    });
  };

  const updateFormData = (target: XY_CMP_GROUP_SET) => {
    setGroupName(target.GROUP_NAME);
    setDevIdx(target.DEV_INDEX);
    setPlcNoX(target.PLC_NO_X);
    setSetNoX(target.SET_NO_X);
    setPlcNoY(target.PLC_NO_Y);
    setSetNoY(target.SET_NO_Y);
    setGroupNo(target.GROUP_NO);

    let xyGroupSetData: XY_CMP_GROUP_SET = {
      GROUP_NO: target.GROUP_NO,
      GROUP_NAME: target.GROUP_NAME,
      DSP_FLG: target.DSP_FLG,
      DEV_INDEX: target.DEV_INDEX,
      PLC_NO_X: target.PLC_NO_X,
      SET_NO_X: target.SET_NO_X,
      PLC_NO_Y: target.PLC_NO_Y,
      SET_NO_Y: target.SET_NO_Y,
      YEAR_FLG: target.YEAR_FLG,
      MONTH_FLG: target.MONTH_FLG,
      START_DATE: (target.START_DATE === null ? dayjs(fromCalendar).format('YYYY-MM-DD') : target.START_DATE),
      END_DATE: (target.END_DATE === null ? dayjs(toCalendar).format('YYYY-MM-DD') : target.END_DATE),
      START_MONTH1: target.START_MONTH1,
      END_MONTH1: target.END_MONTH1,
      DSP_COLOR1: target.DSP_COLOR1 === null ? DspColor1 : target.DSP_COLOR1,
      START_MONTH2: target.START_MONTH2,
      END_MONTH2: target.END_MONTH2,
      DSP_COLOR2: target.DSP_COLOR2 === null ? DspColor2 : target.DSP_COLOR2,
      START_MONTH3: target.START_MONTH3,
      END_MONTH3: target.END_MONTH3,
      DSP_COLOR3: target.DSP_COLOR3 === null ? DspColor3 : target.DSP_COLOR3,
      START_MONTH4: target.START_MONTH4,
      END_MONTH4: target.END_MONTH4,
      DSP_COLOR4: target.DSP_COLOR4 === null ? DspColor4 : target.DSP_COLOR4,
    }
    setEdit(xyGroupSetData);
  };

  /**
   * 日付設定変更処理
   * @param value 
   */
  const onChangeSelectDataUpdate = (value: XY_CMP_GROUP_SET) => {
    //console.debug(['onChangeSelectDataUpdate check1', editList])
    editList.map((r) => {
      if (r.GROUP_NO === value.GROUP_NO) {
        r.YEAR_FLG = value.YEAR_FLG;
        r.MONTH_FLG = value.MONTH_FLG;
        r.START_DATE = value.START_DATE
        r.END_DATE = value.END_DATE
        r.DSP_COLOR1 = value.DSP_COLOR1;
        r.DSP_COLOR2 = value.DSP_COLOR2;
        r.DSP_COLOR3 = value.DSP_COLOR3;
        r.DSP_COLOR4 = value.DSP_COLOR4;
        r.START_MONTH1 = value.START_MONTH1;
        r.START_MONTH2 = value.START_MONTH2;
        r.START_MONTH3 = value.START_MONTH3;
        r.START_MONTH4 = value.START_MONTH4;
        r.END_MONTH1 = value.END_MONTH1;
        r.END_MONTH2 = value.END_MONTH2;
        r.END_MONTH3 = value.END_MONTH3;
        r.END_MONTH4 = value.END_MONTH4;
      }
    });

    console.debug(['onChangeSelectDataUpdate check', editList])
    setEditList(editList);
    props.editData.Target = { list: editList };
    props.editData.IsUpdate = true;
  };

  /**
   * 月設定重複チェック
   * @param value 
   * @returns 
   */
  const checkMonthSettings = (value: XY_CMP_GROUP_SET): string => {
    let errorMsg = t('XYComparisonSetting.月設定の範囲が重複している箇所があります', '月設定の範囲が重複している箇所があります');
    //月設定1との重複チェック
    if (!isNullOrZero(value.START_MONTH1) && !isNullOrZero(value.END_MONTH1)) {
      if (!isNullOrZero(value.START_MONTH2) && !isNullOrZero(value.END_MONTH2)) {
        let result = checkMonths(value.START_MONTH1, value.START_MONTH2, value.END_MONTH1, value.END_MONTH2)
        if (result == true) {
          return errorMsg;
        }
      }
      if (!isNullOrZero(value.START_MONTH3) && !isNullOrZero(value.END_MONTH3)) {
        let result = checkMonths(value.START_MONTH1, value.START_MONTH3, value.END_MONTH1, value.END_MONTH3)
        if (result == true) {
          return errorMsg;
        }
      }
      if (!isNullOrZero(value.START_MONTH4) && !isNullOrZero(value.END_MONTH4)) {
        let result = checkMonths(value.START_MONTH1, value.START_MONTH4, value.END_MONTH1, value.END_MONTH4)
        if (result == true) {
          return errorMsg;
        }
      }
    }
    //月設定2との重複チェック
    if (!isNullOrZero(value.START_MONTH2) && !isNullOrZero(value.END_MONTH2)) {
      if (!isNullOrZero(value.START_MONTH3) && !isNullOrZero(value.END_MONTH3)) {
        let result = checkMonths(value.START_MONTH2, value.START_MONTH3, value.END_MONTH2, value.END_MONTH3)
        if (result == true) {
          return errorMsg;
        }
      }
      if (!isNullOrZero(value.START_MONTH4) && !isNullOrZero(value.END_MONTH4)) {
        let result = checkMonths(value.START_MONTH2, value.START_MONTH4, value.END_MONTH2, value.END_MONTH4)
        if (result == true) {
          return errorMsg;
        }
      }
    }
    //月設定3との重複チェック
    if (!isNullOrZero(value.START_MONTH3) && !isNullOrZero(value.END_MONTH3)) {
      if (!isNullOrZero(value.START_MONTH4) && !isNullOrZero(value.END_MONTH4)) {
        let result = checkMonths(value.START_MONTH3, value.START_MONTH4, value.END_MONTH3, value.END_MONTH4)
        if (result == true) {
          return errorMsg;
        }
      }
    }
    return ''
  }

  /**
   * 月設定範囲の共通重複チェック
   * @param startMonth1 比較元
   * @param startMonth2 比較対象
   * @param endMonth1 比較元
   * @param endMonth2 比較対象
   * @returns 
   */
  const checkMonths = (startMonth1: number, startMonth2: number, endMonth1: number, endMonth2: number): boolean => {
    let spansYear1 = endMonth1 < startMonth1; // 1側の終了月が年をまたぐか
    let spansYear2 = endMonth2 < startMonth2; // 2側の終了月が年をまたぐか
    console.debug(['checkMonths input datas', startMonth1, endMonth1, startMonth2, endMonth2])
    if (spansYear1 && spansYear2) {
      //両方年をまたいでいる場合 => 重複
      return true;
    }
    else if (spansYear1) {
      //片方が年をまたいでいる場合 => 範囲内に重複があるか確認
      return (
        (startMonth1 <= endMonth2 || endMonth1 >= startMonth2)
      );
    }
    else if (spansYear2) {
      //片方が年をまたいでいる場合 => 範囲内に重複があるか確認
      return (
        (startMonth2 <= endMonth1 || endMonth2 >= startMonth1)
      );
    }
    // 年をまたがない場合の通常の重複チェック
    return (
      (startMonth1 >= startMonth2 && startMonth1 <= endMonth2) ||
      (endMonth1 >= startMonth2 && endMonth1 <= endMonth2) ||
      (startMonth1 <= startMonth2 && endMonth1 >= endMonth2)
    );
  }

  return (
    <div>
      <TableContainer>
        <Table className={classes.tableStyle}>
          <TableBody>
            <TableRow className={classes.rowStyle}>
              <TableCell className={classes.cellName + ' ' + classes.cellStyle}>
                {t('XYComparisonSetting.グループNo', 'グループNo')}
              </TableCell>
              <TableCell className={classes.cellData + ' ' + classes.cellStyle}>
                <ItemComboBox
                  itemList={groupCombos}
                  label=""
                  value={groupNo}
                  onChangeEvent={(e) => {
                    if (typeof e.target.value === 'number') {
                      groupChange(e.target.value);
                    } else if (typeof e.target.value === 'string') {
                      groupChange(parseInt(e.target.value));
                    }
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow className={classes.rowStyle}>
              <TableCell className={classes.cellName + ' ' + classes.cellStyle}>
                {t('XYComparisonSetting.グループ名称', 'グループ名称')}
              </TableCell>
              <TableCell className={classes.cellData + ' ' + classes.cellStyle}>
                <TextField
                  value={groupName}
                  inputProps={{ maxLength: 32 }}
                  onChange={(e) => {
                    groupNameChange(e.target.value);
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        {/** 機器番号・XY項目設定 */}
        <Table className={classes.gridStyle}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.headerCell} width={'180px'}>
                {t('XYComparisonSetting.機器番号', '機器番号')}
              </TableCell>
              <TableCell className={classes.headerCell} width={'400px'}>
                {t('XYComparisonSetting.計測種別X', '計測種別X')}
              </TableCell>
              <TableCell className={classes.headerCell} width={'200px'}>
                {t('XYComparisonSetting.計測種別', '計測種別')}
              </TableCell>
              <TableCell className={classes.headerCell} width={'400px'}>
                {t('XYComparisonSetting.計測種別Y', '計測種別Y')}
              </TableCell>
              <TableCell className={classes.headerCell} width={'200px'}>
                {t('XYComparisonSetting.項目', ' 項目')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <XYDeviceItem
              selectList={selectList}
              deviceIdx={devIdx}
              plcNoX={plcNoX}
              setNoX={setNoX}
              plcNoY={plcNoY}
              setNoY={setNoY}
              groupNo={groupNo}
              plcSetFunc={groupPlcSet}
            />
          </TableBody>
        </Table>
        {/** 余白 */}
        <div style={{ margin: '16px 0' }} />
        {/**カレンダー設定 */}
        {<XYDateSettingsProps
          selectData={edit}
          onChangeSelectDataEvent={(e) => onChangeSelectDataUpdate(e)}
        />}
        <SaveCancel
          saveAction={() => {
            setDlgmsg(t('XYComparisonSetting.保存しますか?', '保存しますか?'));
            actCfmDlg
              .open()
              .apply((_) => {
                updateDispFlg();
                saveCurrentSetting({ list: editList }).then((_) => {
                  console.debug(["test test", props.isDialog])
                  props.editData.IsUpdate = false; //X-Y分布図のグラフ表示側でapplyを使用するために必要
                  if (props.isDialog) {
                    props.editData.IsSaveClose = true;
                    props.editData.CloseSetting();
                  }
                });
              })
              .cancel(() => { });
          }}
          /**
           * キャンセル処理
           */
          cancelAction={() => {
            if (props.editData.IsUpdate) {
              setDlgmsg(
                t(
                  'XYComparisonSetting.保存していないデータを破棄します。\nよろしいですか?',
                  '保存していないデータを破棄します。\nよろしいですか?'
                )
              );
              actCfmDlg
                .open()
                .apply((_) => {

                  if (props.isDialog) {
                    props.editData.IsUpdate = false;
                    props.editData.CloseSetting();
                  }
                  else {
                    props.editData.UpdateCancel();
                    //props.editData.CloseSetting();
                  }
                })
                .cancel(() => { });
            } else {
              if (props.isDialog) {
                props.editData.CloseSetting();
              }
            }
          }}
          /**
           * 新規作成
           */
          createAction={() => {
            actCrtDlg.open().apply((info) => {
              const grp = editList.find((ed) => ed.GROUP_NO == info.no);
              if (!grp) {
                const newGrp: XY_CMP_GROUP_SET = {
                  GROUP_NO: info.no,
                  GROUP_NAME: '',
                  DSP_FLG: 0,
                  DEV_INDEX: 0,
                  PLC_NO_X: 0,
                  SET_NO_X: 0,
                  PLC_NO_Y: 0,
                  SET_NO_Y: 0,
                  YEAR_FLG: 0,
                  MONTH_FLG: 0,
                  START_DATE: dayjs(fromCalendar).format('YYYY-MM-DD'),
                  END_DATE: dayjs(toCalendar).format('YYYY-MM-DD'),
                  START_MONTH1: 0,
                  END_MONTH1: 0,
                  DSP_COLOR1: DspColor1,  //赤色
                  START_MONTH2: 0,
                  END_MONTH2: 0,
                  DSP_COLOR2: DspColor2, //青色
                  START_MONTH3: 0,
                  END_MONTH3: 0,
                  DSP_COLOR3: DspColor3,  //緑色
                  START_MONTH4: 0,
                  END_MONTH4: 0,
                  DSP_COLOR4: DspColor4, //水色
                };
                const newList = editList.concat(newGrp).sort((g1, g2) => g1.GROUP_NO - g2.GROUP_NO);
                setEditList([...newList]);

                const groups = newList.map<ComboBoxItemType>((grp) => {
                  return { index: grp.GROUP_NO, name: grp.GROUP_NO.toString() };
                });
                setGroupCombos(groups);
                updateFormData(newGrp);
              }
            });
          }}
          /**
           * 削除処理
           */
          deleteAction={() => {
            setDlgmsg(t('XYComparisonSetting.削除しますか?', '削除しますか?'));
            actCfmDlg.open().apply((_) => {
              const grp = editList.find((ed) => ed.GROUP_NO == groupNo);
              if (grp) {
                grp.GROUP_NAME = '';
                deleteCurrentSetting({ list: editList }).then((_) => {
                  props.editData.IsSaveClose = true;
                  props.editData.IsUpdate = false;
                  let newList = editList.filter((ph) => ph.GROUP_NAME !== '');
                  setEditList([...newList]);
                  const groups = newList.map<ComboBoxItemType>((grp) => {
                    return { index: grp.GROUP_NO, name: grp.GROUP_NO.toString() };
                  });
                  setGroupCombos(groups);
                  if (newList.length !== 0) {
                    updateFormData(newList[0]);
                  }
                });
              }
            });
          }}
        />
      </TableContainer>
      {cfmdlg}
      {msgdlg}
      {crtdlg}
    </div>
  );
};
XYComparisonSetting.defaultProps = { isDialog: false };

export default XYComparisonSetting;
